module.exports = __webpack_public_path__ + "img/pentatlon.6141914b.png";